import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface JournalEntryRequest {
  description?: string;
  glPeriodId?: number;
  amount?: number;
}

const useJournalEntryApi = (glCdId?: string, companyId?: string) => {
  const call = useCallback(
    async (params?: JournalEntryRequest) => {
      try {
        if (!params?.amount) {
          throw new Error('amount is greater than zero');
        } else if (!params?.description) {
          throw new Error('description is empty');
        } else if (!params?.glPeriodId) {
          throw new Error('glPeriodId is empty');
        }
        const res = await axiosInstance.post(
          api.journalEntry(glCdId || '', companyId || ''),
          params
        );
        return res?.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId, glCdId]
  );

  const { isLoading, execute } = useAsync<any, JournalEntryRequest>(call, false);

  return { journalEntry: execute, journalEntryLoading: isLoading };
};

export default useJournalEntryApi;
